import StatusMessage from "./StatusMessage";

function AppToast({ title, subtitle, type = "success" }) {
  return <StatusMessage title={title} subtitle={subtitle} variant={type} />;
}

export default AppToast;
